import './InfoBoxes.css'
import {useState} from 'react'

function InfoBoxes(props) {
    const [openSvinnsmart, setOpenSvinnsmart] = useState(false)
    const [openKlimatkoll, setOpenKlimatkoll] = useState(false)
    const [openForvaring, setOpenForvaring] = useState(false)

    const openOrCloseContent = (whatContentToOpenOrClose) => {
        if (whatContentToOpenOrClose === "svinnsmart") setOpenSvinnsmart(!openSvinnsmart)
        if (whatContentToOpenOrClose === "klimatkoll") setOpenKlimatkoll(!openKlimatkoll)
        if (whatContentToOpenOrClose === "forvaring") setOpenForvaring(!openForvaring)
    }

    return (
        <>
            {props.singleItem.svinnsmart ?
                <>
                    <div 
                        className="moreInfoHeader" 
                        onClick={() => openOrCloseContent("svinnsmart")}
                    >
                        <div>
                            Svinnsmart
                        </div>
                        <div>
                            <img 
                                src={openSvinnsmart ? "/img/arrow-up.png" : "/img/arrow-down.png"} 
                                alt="Öppna/Stäng"
                            />
                        </div>
                    </div>
                    
                    {openSvinnsmart ? 
                        <div className="moreInfoContent">
                            {props.singleItem.svinnsmart}
                        </div> 
                    : 
                        null
                    }
                </>
            :
                null
            }
            
            {props.singleItem.klimatkoll ?
                <>
                    <div 
                        className="moreInfoHeader" 
                        onClick={() => openOrCloseContent("klimatkoll")}
                    >
                        <div>
                            Klimatkoll
                        </div>
                        <div>
                            <img 
                                src={openKlimatkoll ? "/img/arrow-up.png" : "/img/arrow-down.png"} 
                                alt="Öppna/Stäng" 
                            />
                        </div>
                    </div>
            
                    {openKlimatkoll ? 
                        <div className="moreInfoContent">
                            {props.singleItem.klimatkoll}
                        </div> 
                    : 
                        null}
                </>
            :
                    null
            }

            {props.singleItem.forvaring ?
                <>
                    <div 
                        className="moreInfoHeader" 
                        onClick={() => openOrCloseContent("forvaring")}
                    >
                        <div>
                            Förvaring
                        </div>
                        <div>
                            <img 
                                src={openForvaring ? "/img/arrow-up.png" : "/img/arrow-down.png"} 
                                alt="Öppna/Stäng" 
                            />
                        </div>
                    </div>

                    {openForvaring ? 
                        <div className="moreInfoContent">
                            {props.singleItem.forvaring}
                        </div> 
                    : 
                        null
                    }
                </>
            :
                null
            }
        </>
    )
}
            
export default InfoBoxes